module.exports = __webpack_public_path__ + "img/business-befikar.71837fff.png";